import {datasetAnalytics} from '..'
import { getConstant } from 'commons/js/constants'
import { composeScreenEvent } from 'commons/js/services/analytics/TealiumEventsCollection/utils'

export const getCustomAnalyticEvents = () => {
    const appName = getAppNameFromDomain()
    const ANALYTICS_EVENTS_BY_EVENT_ID = {
        'notFound': showNotFoundScreen({url: window?.location?.href, appName}),
    }

    const event = ANALYTICS_EVENTS_BY_EVENT_ID[datasetAnalytics.eventId]
    if (!event) throw new Error(`not event found for this eventId:  ${datasetAnalytics.eventId}`)
    return event
}

export function getAppNameFromDomain () {
    const domainApp = {
        MUTUAMAS_VIAT_MODULE_URLS: 'viat',
        MUTUAMAS_VIAT_MODULE_MOBILE_URLS: 'viat',
        MUTUAMAS_DRIVER_PLUS_MODULE_URLS: 'driverplus',
        MUTUAMAS_RENTAL_CAR_MODULE_URLS: 'alquiler',
        MUTUAMAS_RENTAL_CAR_MOBILE_MODULE_URLS: 'alquiler',
        MUTUAMAS_PROCESS_MODULE_URLS: 'process',
    }
    const currentUrl = getConstantOrNull('MUTUAMAS_URL') ?? window.location.href
    const currentDomain = new URL(currentUrl).hostname

    for (const key in domainApp) {
            let url = getConstantOrNull(key)

            if (url) {
                url = url.split(/\s+/)[0]
                const domain = new URL(url).hostname
                if (currentDomain.includes(domain)) {
                    return domainApp[key]
                }
            }
    }

    return 'NoApp'
}

const getConstantOrNull = (key) => {
    try {
        const value = getConstant(key)
        return value
    } catch (err) {
        return null
    }
}

// Custom events
export const showNotFoundScreen = ({ url = 'no Url found', appName = 'noApp' }) => composeScreenEvent({
    screenClass: appName,
    tipoOperativa: appName,
    tipologia: 'movilidad',
    subtipologia: 'transaccional',
    seccion1: 'mis productos',
    seccion2: appName,
    seccion3: 'url no encontrada',
    screenName: `${appName} error generico url no encontrada`,
    urlPage: url,
})
